import { lazy, Suspense, useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "./theme/Layout";
import "./App.css";
import Login from "./pages/Login/Login";
import ProtectedRoute from "./routes/ProtectedRoute";
import VerifyOtp from "./pages/Verify-otp/VerifyOtp";
import { useTranslation } from "react-i18next";
import TermsAndConditions from "./pages/Terms-and-conditions/TermsAndConditions";
import AboutUsDetails from "./components/About-us-details/AboutUsDetails";
import LoaderSpinner from "./shared/sharedComponents/loaderSpinner/LoaderSpinner";
import { useDispatch, useSelector } from "react-redux";
import {
  getLocalStorageData,
  setLocalStorageData,
} from "./shared/commonFunction";
import GoogleAnalytics from "./google-analytics/GoogleAnalytics";
import { setAdsState } from "./features/sharingAdvertisment/SharingAdSlice";
import DeleteAccount from "./pages/deleteAccountPage/DeleteAccount";
import CartPage from "./components/market-place/Cart-page/CartPage";
import OrdersList from "./components/market-place/Order-page/Orders-List/OrdersList";
import AllProductsPage from "./components/market-place/All-Products/AllProductPage";

const OrderDetails = lazy(() =>
  import("./components/market-place/Order-page/Order-Details-Page/OrderDetails")
);

const OneToOneGameRules = lazy(() =>
  import(
    "./components/One-to-one-games/One-to-one-game-rules/OneToOneGameRules"
  )
);
const OneToOneGames = lazy(() =>
  import("./components/One-to-one-games/OneToOneGames")
);
const ScoreSubmissionOneToOne = lazy(() =>
  import(
    "./components/One-to-one-games/Score-submission-one-to-one/ScoreSubmissionOneToOne"
  )
);

const OneToOneGameRoom = lazy(() =>
  import("./components/One-to-one-games/One-to-one-game-room/OneToOneGameRoom")
);

const Wallet = lazy(() => import("./components/user-profile/wallet/Wallet"));

const Result = lazy(() => import("./components/Result/Result"));
const Tournaments = lazy(() => import("./components/Tournament/Tournaments"));
const EditUserProfile = lazy(() =>
  import("./components/user-profile/edit-user-profile/EditUserProfile")
);
const JoinTournament = lazy(() =>
  import("./components/Tournament/join-tournament/JoinTournament")
);
const Message = lazy(() => import("./components/Chat/Messages/Message"));
const HomePage = lazy(() => import("./components/HomePage"));
const FeatureTournament = lazy(() =>
  import("./components/Feature-tournament/FeatureTournament")
);
const LeaderShipBoard = lazy(() =>
  import("./components/Leader-ship-board/LeaderShipBoard")
);
const Academy = lazy(() => import("./components/Academy/Academy"));
const Consumerprofile = lazy(() =>
  import("./components/Consumer-profile/Consumer-Profile")
);
const FeaturedRegiter = lazy(() =>
  import("./components/Register-featured/RegisterFeatured")
);

const ContactUs = lazy(() => import("./components/Contact-us/ContactUs"));
// const AboutUs = lazy(() => import("./components/About-us/AboutUs"));
const JoinOurCommunty = lazy(() =>
  import("./components/Join-our-community/JoinOurCommunity")
);

const SignUp = lazy(() => import("./pages/Sign-up/SignUp"));
const ForgotPassword = lazy(() =>
  import("./pages/Forgot-password/ForgotPassword")
);

const Store = lazy(() =>
  import("./components/market-place/Store-Page/StorePage")
);

const ProductDetailsPage = lazy(() =>
  import("./components/market-place/Product-detail-page/ProductDetailsPage")
);

const UserProfile = lazy(() => import("./components/user-profile/UserProfile"));

const LoadingFallback = () => {
  const { t } = useTranslation("common");
  return <div className="lazy-loading">{t("menu.loading")}</div>;
};

const NotFound = () => {
  const { t } = useTranslation("common");
  return (
    <h1 style={{ color: "#fff", textAlign: "center" }}>
      {t("website_heading.page_not_found")}
    </h1>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <HomePage />
          </Suspense>
        ),
      },
      {
        path: "/one-to-one",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <OneToOneGames />
          </Suspense>
        ),
      },
      {
        path: "/tournaments",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <FeatureTournament />
          </Suspense>
        ),
      },
      {
        path: "/leadership-board",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <LeaderShipBoard />
          </Suspense>
        ),
      },

      {
        path: "/edit-user-profile",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <EditUserProfile />
          </Suspense>
        ),
      },

      {
        path: "/academy",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <Academy />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/contact-us",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <ContactUs />
          </Suspense>
        ),
      },
      {
        path: "/about-us",
        element: <AboutUsDetails />,
      },

      {
        path: "/join-our-community",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <JoinOurCommunty />
          </Suspense>
        ),
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/sign-up",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <SignUp />
          </Suspense>
        ),
      },

      {
        path: "/terms-conditions",
        element: <TermsAndConditions />,
      },

      {
        path: "/forgot-password",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <ForgotPassword />
          </Suspense>
        ),
      },
      {
        path: "/verify-otp",
        element: <VerifyOtp />,
      },
      {
        path: "/profile",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <UserProfile />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/wallet",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <Wallet />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/messages",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <Message />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/join-tournament",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <JoinTournament />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/consumer-Profile/:id",
        element: (
          // <ProtectedRoute>
          <Suspense fallback={<LoadingFallback />}>
            <Consumerprofile />
          </Suspense>
          // </ProtectedRoute>
        ),
      },
      {
        path: "/register-featured/:id",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <FeaturedRegiter />
          </Suspense>
        ),
      },
      {
        path: "/all-tournaments",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <Tournaments />
          </Suspense>
        ),
      },
      {
        path: "/my-tournaments",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <Tournaments />
          </Suspense>
        ),
      },
      {
        path: "/result/:id/:currentRound/:opponentId",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <Result />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/one-to-one-message/:id",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <OneToOneGameRoom />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/one-to-one-score-submission",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <ScoreSubmissionOneToOne />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/game-rules/:id",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <OneToOneGameRules />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/store",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <Store />
          </Suspense>
        ),
      },
      {
        path: "/all-products",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <AllProductsPage />
          </Suspense>
        ),
      },
      {
        path: "/product-details",
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <ProductDetailsPage />
          </Suspense>
        ),
      },
      {
        path: "/my-cart",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <CartPage />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/my-orders",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <OrdersList />
            </Suspense>
          </ProtectedRoute>
        ),
      },
      {
        path: "/order-details",
        element: (
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}>
              <OrderDetails />
            </Suspense>
          </ProtectedRoute>
        ),
      },

      {
        path: "/delete-account",
        element: <DeleteAccount />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
]);

function App() {
  const { isLoading } = useSelector((state) => state.loader);
  // const dispatch = useDispatch();
  const { t } = useTranslation("common");

  // Handle default language
  const defaultLanguage = getLocalStorageData("language") || "ar";
  if (defaultLanguage) {
    setLocalStorageData("language", defaultLanguage);
  }

  // Handle ads properly
  // const storedAds = getLocalStorageData("ads");
  // const parsedAds = storedAds === "false" ? false : storedAds == null ? true : !!storedAds;
  // useEffect(() => {
  //   dispatch(setAdsState(parsedAds));
  // }, [dispatch, parsedAds]);

  useEffect(() => {
    document.title = t("website_heading.page_title");
  }, [t]);

  return (
    <>
      {isLoading ? <LoaderSpinner /> : null}
      <RouterProvider router={router}>
        <GoogleAnalytics />
      </RouterProvider>
    </>
  );
}

export default App;
